import type { RegisteredLinkProps } from "@codegouvfr/react-dsfr/link";
import { domElementIds, frontRoutes } from "shared";
import type { VersionnedStandardContent } from "./textSetup";

export default {
  latest: {
    title: "Plan du site",
    content: () => <LatestSiteMapContent />,
  },
} satisfies VersionnedStandardContent;

const { siteMap: siteMapIds } = domElementIds.standard;

const siteMapLinks: RegisteredLinkProps[] = [
  {
    title: "Accueil",
    id: siteMapIds.home,
    ...frontRoutes.home().link,
  },
  {
    title: "Accueil candidat",
    id: siteMapIds.candidateHome,
    ...frontRoutes.homeCandidates().link,
  },
  {
    title: "Accueil entreprise",
    id: siteMapIds.establishmentHome,
    ...frontRoutes.homeEstablishments().link,
  },
  {
    title: "Accueil prescripteurs",
    id: siteMapIds.agencyHome,
    ...frontRoutes.homeAgencies().link,
  },
  {
    title: "Trouver une entreprise accueillante",
    id: siteMapIds.search,
    ...frontRoutes.search().link,
  },
  {
    title: "Remplir la demande de convention",
    id: siteMapIds.coventionForm,
    ...frontRoutes.conventionImmersion().link,
  },
  {
    title: "Référencer une entreprise",
    id: siteMapIds.establishmentForm,
    ...frontRoutes.formEstablishment().link,
  },
  {
    title: "Référencer un organisme",
    id: siteMapIds.agencyForm,
    ...frontRoutes.addAgency().link,
  },
  {
    title: "Accessibilité",
    id: siteMapIds.accessibility,
    ...frontRoutes.standard({ pagePath: "accessibilite" }).link,
  },
  {
    title: "Mentions légales",
    id: siteMapIds.legals,
    ...frontRoutes.standard({ pagePath: "mentions-legales" }).link,
  },
  {
    title: "Politique de confidentialité",
    ...frontRoutes.standard({ pagePath: "politique-de-confidentialite" }).link,
    id: siteMapIds.privacy,
  },
  {
    title: "Conditions générales d'utilisation",
    ...frontRoutes.standard({ pagePath: "cgu" }).link,
    id: siteMapIds.cgu,
  },
  {
    title: "Statistiques",
    href: "/stats",
    id: siteMapIds.stats,
  },
];

const LatestSiteMapContent = () => (
  <ul>
    {siteMapLinks.map((link) => (
      <li key={link.id}>
        <a
          className="fr-link fr-fi-arrow-right-line fr-link--icon-right"
          href={link.href}
          id={link.id}
        >
          {link.title}
        </a>
      </li>
    ))}
  </ul>
);
